import { useMarketSearchStore } from '../../utils'
import { navigate } from 'gatsby'

export const openMarketSearch = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : ''
  if (useMarketSearchStore.getState().marketSearchToggled) {
    navigate(`${path}`)
  } else {
    navigate(`${path}?marktsuche=marktfinder`)
  }

  useMarketSearchStore.setState({
    marketSearchToggled: !useMarketSearchStore.getState().marketSearchToggled
  })
}
